import React from "react";
import Field from "./Field";

export default function PasswordField(props: Omit<React.ComponentProps<typeof Field>, "type">) {
    const [show, setShow] = React.useState(false);
    return (
        <Field
            {...props}
            type={show ? "text" : "password"}
            leftIcon={<LockIcon />}
            rightIcon={
                <button type="button" onClick={() => setShow((p) => !p)} 
                className="flex items-center justify-center h-5 w-5 text-black/50 focus:outline-none"
                >
                    {show ? <EyeOff /> : <Eye />}
                </button>
            }
        />
    );
}

const LockIcon = () => (
    // <span className="material-icons text-base">lock</span>
    <span className="material-icons text-[18px] leading-none">lock</span>
);
const Eye = () => (
    // <span className="material-icons text-base">visibility_off</span>
    <span className="material-icons text-[18px] leading-none">visibility_off</span>
);
const EyeOff = () => (
    // <span className="material-icons text-base">visibility</span>
    <span className="material-icons text-[18px] leading-none">visibility</span>
);
